import { LocalDate } from '@js-joda/core';

import { PatientClearPregnantCommand, PregnancyCompletionType, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { FormContextValues } from '@dreryk/react-common';
import { ButtonVariant, dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

const t = visitPatientPregnancyStatusTranslationKeys;

type PatientClearPregnancyCommandParameters = {
   completionType: PregnancyCompletionType | null;
   completionDate: LocalDate | null;
};

type PatientPregnancyCompletionMarkingModalConfirmButtonProps = {
   readonly visitId: number;
   readonly handleSubmit: FormContextValues<PatientClearPregnancyCommandParameters>['handleSubmit'];
   readonly onSuccess: VoidFunction;
   readonly registerMedicalEvent: boolean;
};

export const PatientPregnancyCompletionMarkingModalConfirmButton = (
   props: PatientPregnancyCompletionMarkingModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: markPatientPregnancy } = useCqrsCommand<void, PatientClearPregnancyCommandParameters>(
      (parameters) => {
         const command = new PatientClearPregnantCommand();
         command.visitId = props.visitId;
         command.completionDate = Choice.withUseDefaultIfNull(
            parameters.completionDate ? parameters.completionDate : null
         );
         command.completionType = parameters.completionType!;
         command.registerMedicalEvent = props.registerMedicalEvent;
         return command;
      },
      {
         onSuccess: () => {
            if (props.registerMedicalEvent) {
               dispatchSnackbarPositiveEvent(t.pregnancyCompletionMarkedSuccessfullyWithMedicalEvent);
            } else {
               dispatchSnackbarPositiveEvent(t.pregnancyCompletionMarkedSuccessfully);
            }

            refetchCqrsQuery(VisitQuery);
            props.onSuccess();
         },
      }
   );
   return (
      <ModalConfirmButton
         label={props.registerMedicalEvent ? t.markPregnancyCompletionAndSendToP1 : t.markPregnancyCompletion}
         onClick={props.handleSubmit(markPatientPregnancy)}
         variant={props.registerMedicalEvent ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
         testId={
            props.registerMedicalEvent ? 'markPatientPregnancyCompletionAndSendToP1' : 'markPatientPregnancyCompletion'
         }
      />
   );
};
